import React from 'react';

import { GeojsonFeature } from '@foreflight/webmap/core';
import { GeojsonLayer } from '@foreflight/webmap/react';

import { Segment } from 'ff/debrief/models';
import { getScoreColor } from 'ff/debrief/utils';

interface Props {
    segments: (Segment & { points: number[][] })[];
}

const ScoredSegmentsLayer: React.FC<Props> = props => {
    const features: GeojsonFeature[] = props.segments.map(segment => ({
        type: 'Feature',
        properties: {
            color: getScoreColor(segment.score),
            width: 5,
            cap: 'square',
            outlineColor: '#000',
            outlineWidth: 1,
        },
        geometry: {
            type: 'LineString',
            coordinates: segment.points.map(point => [point[2], point[1]]),
        },
    }));

    return <GeojsonLayer features={features} priority={30} />;
};

export default ScoredSegmentsLayer;
